import { load as loadPage } from '@glimja/storefront/pages/slug';
import { error, redirect, type Load } from '@sveltejs/kit';
import { getLocaleFromUrl } from '@glimja/shared/utils';

const getPage = async (event: Load) => {
  try {
    const data = await loadPage(event as unknown as any);
    return data;
  } catch {
    error(404, 'Not found')
  }
}

export const load: Load = async (event) => {
  const { url } = event;

  // check if the url has uppercase characters, in that case redirect to lowercase url
  const lowercasePathname = url.pathname.toLowerCase();
  if (url.pathname !== lowercasePathname) {
    redirect(301, lowercasePathname);
  }

  // check if the pathname is the correct slug or if it's the default language, if it's a mismatch redirect to the chosen language
  const data = await getPage(event as unknown as any);
  const locale = getLocaleFromUrl(url);
  const slug = data.pageData.slug.split('/').pop();
  const fullPathName = `${locale.language !== locale.defaultLanguage ? '/' + locale.language : ''}/${slug}`;

  if (fullPathName !== lowercasePathname) {
    redirect(301, fullPathName);
  }
  return data;
};
